<template>
  <div v-if="classroom">
    <div class="title is-4">
      <span>{{ classroom.course.name }}</span>
      <div
        class="button is-small is-rounded is-primary is-pulled-right"
        @click="$emit('edit_classroom', classroom)"
      >
        <span class="icon">
          <i class="fa fa-edit"></i>
        </span>
        <span>{{ $t("edit") }}</span>
      </div>
    </div>

    <div class="subtitle is-5 mb-0">
      {{ classroom.professor.first_name }}
      {{ classroom.professor.first_surname }}
    </div>
    <div class="subtitle is-5">
      {{ classroom.period.name }}
    </div>
    <div class="title is-5 mt-5 mb-1">{{ $t("classroom settings") }}</div>
    <div class="columns">
      <div class="column">
        <span class="icon">
          <i class="fa fa-globe"></i>
        </span>
        <span
          class="is-size-6"
          v-if="
            classroom &&
            classroom.settings &&
            classroom.settings.virtual_classroom_url
          "
        >
          {{ classroom.settings.virtual_classroom_url }}
        </span>
        <span class="is-size-6 has-text-warning" v-else>{{
          $t("no virtual classroom set yet")
        }}</span>
      </div>
      <!-- <div class="column"></div> -->
    </div>

    <!-- <pre>{{ classroom.settings }}</pre> -->
    <div class="title is-5">{{ $t("students") }}</div>
    <table
      class="table is-fullwidth"
      v-if="
        classroom && classroom.student_list && classroom.student_list.length
      "
    >
      <thead>
        <tr>
          <th>{{ $t("student") }}</th>
          <th>{{ $t("id") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(student, iidx) in classroom.student_list" :key="iidx">
          <td>
            {{ student.name }}
          </td>
          <td>{{ student.id_card_number }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  error_message,
  format_currency,
  input_alert,
} from "@/utils";
import ClassroomDetail from "./ClassroomDetail.vue";

export default {
  name: "ClassroomDetail",
  components: { ClassroomDetail },
  data() {
    return {
      classroom: null,
    };
  },
  computed: {},
  methods: {
    set_classroom(classroom) {
      let v = this;
      get("/student/classroom", { uuid: classroom.uuid })
        .then((response) => {
          v.classroom = response;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    refresh() {
      let v = this;
      if (v.classroom) {
        get("/student/classroom", { uuid: v.classroom.uuid })
          .then((response) => {
            v.classroom = response;
          })
          .catch((error) => {
            error_message(error);
          });
      }
    },
  },
};
</script>

<style scoped></style>
